(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog-collection"]) return;
  try {
    
  $('.slider-gallery').slick({
    'arrows': true,
    'autoplay': false
  });

  $('.next-button').click(function(e) { 
     $('.slider-gallery').slick('slickNext');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["markets-gallery"]) return;
  try {
    
  $('.slider-gallery').slick({
    'arrows': true,
    'autoplay': false
  });

  $('.next-button').click(function(e) { 
     $('.slider-gallery').slick('slickNext');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-gallery"]) return;
  try {
    
  $('.slider-gallery').slick({
    'arrows': true,
    'autoplay': false
  });

  $('.next-button').click(function(e) { 
     $('.slider-gallery').slick('slickNext');
  });

  } catch(e) { console.error(e); }
})();

})();
